import { Button } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AiOutlineArrowLeft } from 'react-icons/ai';

export const BackButton = () => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate(-1);
  };
  return (
    <Button
      leftIcon={<AiOutlineArrowLeft />}
      variant="outline"
      onClick={onClick}
    >
      Back
    </Button>
  );
};
